// extracted by mini-css-extract-plugin
export default {"tabs":"booking_page-module___tabs___cfe14fcc","header":"booking_page-module___header___ae78c050"};